import * as React from 'react';

import { SVGProps } from '../../types';

export const IconSpecificStudentsSvg = ({
  title,
  titleId,
  ...props
}: SVGProps) => (
  <svg
    width={72}
    height={72}
    viewBox="0 0 72 72"
    focusable="false"
    fill="none"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <rect x={16} y={7} width={49} height={64} rx={4} fill="#E4FBFF" />
    <rect
      x={11}
      y={2}
      width={49}
      height={64}
      rx={4}
      stroke="#0099C7"
      strokeWidth={2}
    />
    <circle
      cx={28}
      cy={24}
      r={7}
      stroke="#0099C7"
      strokeWidth={2}
    />
    <circle
      cx={45.5}
      cy={27.5}
      r={5.5}
      stroke="#0099C7"
      strokeWidth={2}
    />
    <path
      d="M29.9941 35H26.0059C21.0321 35 17 39.0321 17 44.0059V51.7251C17 53.5338 18.4662 55 20.2749 55H35.7251C37.5338 55 39 53.5338 39 51.7251V44.0059C39 39.0321 34.9679 35 29.9941 35Z"
      stroke="#0099C7"
      strokeWidth={2}
    />
    <path
      d="M41 37H47.0892C50.9059 37 54 40.7144 54 45.2963V46.8519C54 49.1428 52.453 51 50.5446 51H39"
      stroke="#0099C7"
      strokeWidth={2}
      strokeLinecap="round"
    />
  </svg>
);
